import { Button } from "@/components/ui/button";
import { ArrowRight, Phone } from "lucide-react";
import { CONTACT } from "@/data/content";

export default function StickyMobileCTA({ onCheckEligibility, label = "Check Eligibility" }) {
  return (
    <div
      data-testid="sticky-mobile-cta"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-xl border-t border-gray-200 px-4 py-3 flex items-center gap-2 shadow-[0_-8px_24px_rgba(15,45,82,0.08)]"
    >
      <a href={`tel:+${CONTACT.phoneDigits}`} className="shrink-0">
        <Button
          variant="outline"
          data-testid="sticky-cta-call"
          className="rounded-full border-gray-300 text-[#0F2D52] h-11 w-11 p-0"
          aria-label="Call"
        >
          <Phone className="h-4 w-4" />
        </Button>
      </a>
      <Button
        onClick={onCheckEligibility}
        data-testid="sticky-cta-check"
        className="flex-1 rounded-full bg-[#0F2D52] hover:bg-[#0a1f38] text-white h-11 font-semibold text-sm"
      >
        {label}
        <ArrowRight className="ml-1 h-4 w-4" />
      </Button>
    </div>
  );
}
